function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.92 65.482C57.7032 65.482 17.8419 51.0963 17.8419 33.3177C17.8419 17.4391 49.7309 4.27485 91.7005 1.62842C41.4951 2.98556 1.89746 18.7284 1.89746 37.9998C1.89746 58.0856 45.2506 74.4391 98.7503 74.4391C152.25 74.4391 195.603 58.1534 195.603 37.9998C195.603 37.5248 195.603 37.1177 195.537 36.7106C190.859 52.8606 152.975 65.482 106.92 65.482Z",
  fill: "#FFC731"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.09 72.9463C61.5904 72.9463 18.2373 56.7963 18.2373 36.9141C18.2373 19.5427 51.1804 5.08913 94.9948 1.62842C43.274 2.30699 1.89746 18.3213 1.89746 37.9998C1.89746 58.0856 45.2506 74.4391 98.7503 74.4391C109.556 74.4391 120.032 73.7606 129.717 72.5391C124.973 72.8106 120.097 72.9463 115.09 72.9463Z",
  fill: "#0CB5DD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.5787 36.2354L63.9623 31.8247H64.0282L65.28 36.2354H62.5787ZM63.0399 27.0747C62.4469 27.0747 61.9198 27.414 61.5245 27.8211L56.583 41.2568H60.9974L61.6563 39.2211H66.2024L66.7954 41.2568H71.3415L66.1365 27.0068L63.0399 27.0747Z",
  fill: "#385CAD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M83.53 31.0783L83.8595 30.6711C84.123 30.3318 84.2548 29.9247 84.2548 29.5176V27.0747H72.2635V30.739H78.5227L72.2635 37.4568C72.0658 37.7283 71.9341 38.0676 71.8682 38.4747V41.3247H84.5842V37.6604H77.6003L83.53 31.0783Z",
  fill: "#385CAD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.249 32.6389C167.206 32.0961 165.23 31.8925 165.098 30.8747C165.098 30.0604 166.086 29.9247 166.679 29.9247C167.14 29.9247 167.602 29.9925 167.997 30.2639C168.326 30.5354 168.59 30.8747 168.524 31.4175H172.675C172.543 27.9568 169.842 26.8032 166.745 26.8032C163.846 26.8032 161.013 28.2282 161.013 31.4854C161.013 34.3354 163.582 34.9461 165.823 35.6247C168.26 36.3032 168.919 36.5068 168.919 37.2532C168.919 38.3389 167.799 38.5425 167.074 38.5425C166.284 38.5425 165.296 38.3389 164.966 37.5247C164.834 37.2532 164.834 36.9818 164.834 36.5747H160.42C160.486 41.1211 165.032 41.6639 166.679 41.6639C169.842 41.6639 173.268 40.4425 173.268 36.7782C173.268 34.1318 171.291 33.1818 169.249 32.6389Z",
  fill: "#385CAD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.402 28.2961L137.689 35.4211H137.623L135.91 28.364C135.778 27.6176 135.185 27.0747 134.395 27.0747H129.321V41.3247H133.472V32.164H133.538L136.042 41.2568H139.336L141.774 32.164H141.84V41.2568H145.991V27.0068H140.917C140.127 27.1426 139.534 27.6176 139.402 28.2961Z",
  fill: "#385CAD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M157.85 27.0747C157.257 27.0747 156.73 27.414 156.335 27.8211L154.227 32.2997L152.184 27.8211C152.184 27.8211 152.184 27.8211 152.184 27.7533C151.855 27.3461 151.328 27.0747 150.735 27.0068H147.045L152.052 35.964V41.189H156.467V35.964L161.54 27.0068L157.85 27.0747Z",
  fill: "#385CAD"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.0416 36.2354L92.4252 31.8247H92.4911L93.743 36.2354H91.0416ZM91.5028 27.0747C91.4369 27.0747 91.371 27.0747 91.3052 27.0747H91.2393C91.1734 27.0747 91.1734 27.0747 91.1075 27.0747C91.0416 27.0747 91.0416 27.0747 90.9757 27.1425H90.9098C90.844 27.1425 90.844 27.2104 90.7781 27.2104C90.7781 27.2104 90.7781 27.2104 90.7122 27.2104C90.6463 27.2104 90.5804 27.2783 90.5804 27.2783C90.5145 27.2783 90.4486 27.3461 90.4486 27.414C90.3828 27.4818 90.3169 27.4818 90.3169 27.5497C90.251 27.6175 90.251 27.6175 90.1851 27.6854C90.1851 27.7532 90.1192 27.7533 90.1192 27.8211L85.1777 41.189H89.5921L90.251 39.1532H94.7971L95.3901 41.189H99.9363L94.7312 26.939L91.5028 27.0747Z",
  fill: "#385CAD"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M123.457 32.0283H119.372V27.0747H114.958V41.3247H119.372V35.6926H123.457V41.3247H127.872V27.0747H123.457V32.0283Z",
  fill: "#385CAD"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.0558 27.0747H51.5097C50.9167 27.0747 50.3896 27.414 49.9943 27.8211L46.7 31.9604H46.6341V27.0747H42.2197V41.3247H46.6341V37.1176L47.3589 36.3033L50.5214 41.3247H55.7923L50.2579 33.1818L56.0558 27.0747Z",
  fill: "#385CAD"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.035 27.0747H109.489C108.896 27.0747 108.369 27.414 107.974 27.8211L104.679 31.9604H104.614V27.0747H100.199V41.3247H104.614V37.1176L105.338 36.3033L108.501 41.3247H113.772L108.237 33.1818L114.035 27.0747Z",
  fill: "#385CAD"
});

const SvgLogoBlue = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 198 76",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-blue.e189bcf1.svg";
export { ForwardRef as ReactComponent };